export default function autoReset(modules) {
  Object.keys(modules).forEach((moduleName) => {
    const mod = modules[moduleName];

    if (typeof mod.getDefaultState === "function") {
      mod.mutations = {
        ...mod.mutations,
        RESET_STATE(state) {
          Object.assign(state, mod.getDefaultState());
        },
      };
    }
  });

  return () => {};
}
